import React, { useRef } from "react";
import {
  Autocomplete,
  Backdrop,
  BackdropRoot,
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  MenuItem,
  Select,
  Stack,
  TextField,
  ThemeProvider,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import StarsIcon from "@mui/icons-material/Stars";
import { useEffect, useState, useMemo } from "react";
import CancelIcon from "@mui/icons-material/Cancel";
import { Link, useHistory } from "react-router-dom";
import { useFormik } from "formik";
import * as yup from "yup";

import { createTheme } from "@mui/material/styles";

import { toast } from "react-toastify";
import axios from "axios";
import { ToastContainer } from "react-toastify/dist";
import Loader from "../../../../components/Loader";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";

// tablle imports

import {
  useAsyncDebounce,
  useBlockLayout,
  useColumnOrder,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";

import { useDispatch, useSelector } from "react-redux";

import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import moment from "moment";
import { common_axios } from "../../../../App";
import { setButttonStatus } from "../../../../redux/features/TableSlice";
import { setModalstatus } from "../../../../redux/features/ModalSlice";
import Swal from "sweetalert2";

export default function CSMMarkAttendance() {
  const [open, setOpen] = useState(false);

  const [state, setstate] = useState("");

  const [location, setLocation] = React.useState({
    leaveType: "",
    reason: "",
    showlastdiv: false,
  });
  const [data, setData] = useState([]);
  const [showdata, setshowData] = useState(false);
  const [value, setValue] = React.useState(dayjs(new Date()));
  const [valuee, setValuee] = React.useState();
  const [ee1, setee1] = useState({
    dateform: null,
  });
  const [shyamCode, setshyamCode] = useState(null);

  const [datee, setdatee] = useState({
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
  });

  const [daysDiff, setdaysDiff] = useState(1);
  var [date, setDate] = useState(new Date());
  const [employees, setEmployess] = useState([]);
  const [employeesValue, setEmployessValue] = useState(null);

  useEffect(() => {
    var timer = setInterval(() => setDate(new Date()), 1000);
    return function cleanup() {
      clearInterval(timer);
    };
  });

  const handleChange = (newValue) => {
    setValue(newValue);
  };
  const handleChangee = (newValue) => {
    setValuee(newValue);
  };
  var date = moment(valuee?.$d);
  var now = moment(value?.$d);
  var duration = moment.duration(date.diff(now));
  var noofDays = duration.asDays();

  var stat = moment().format("MMMM Do YYYY, h:mm:ss a");

  useEffect(() => {
    setdaysDiff(Math.ceil(noofDays) + 1);
  }, [value?.$d, valuee?.$d]);

  const mark = useRef(null);

  const markModal = async () => {
    // await setshyamCode(shyamCode);
    await mark.current.click();
  };

  const { globalFilter, pageIndex, pageSize } = state;

  const columns = useMemo(
    () => [
      {
        Header: "S.no",

        accessor: "S.no",
        Cell: (cell) => {
          return <>{cell.row.index + 1}</>;
        },
      },
      {
        Header: "Name",

        accessor: "name",
      },
      {
        Header: "City",

        accessor: "city",
      },
      {
        Header: "Contact No.",

        accessor: "contact",
      },
    ],
    []
  );
  const usermodal = JSON.parse(localStorage.getItem("usermodal"))?.userGroups;

  const markAttendence = async (e) => {
    try {
      setOpen(false);
      const res = await common_axios.post(`/attendance/markAttendance`, {
        userId: localStorage.getItem("UserId"),
        status: 1,
        fromDate: moment(new Date()).format("YYYY-MM-DD"),
        toDate: moment(new Date()).format("YYYY-MM-DD"),
        reason: "",
        numberOfDays: 1,
        userGroup: usermodal,
        userName: localStorage.getItem("usernamedisplayed"),
      });
      if (res.data.statusDescriptions.statusCode == 200) {
        setOpen(false);

        markAttendacne();

        // await setLocation({
        //   ...location,
        //   showlastdiv: true,
        // });

        await setTimeout(async () => {
          Swal.fire({
            icon: "success",
            // title: "Oops...",
            text: res.data.statusDescriptions.statusDescription,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }, 100);
        await markColseModal();
      } else {
        setOpen(false);
        markAttendacne();
        await setTimeout(async () => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescriptions.statusDescription,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }, 100);
        await markColseModal();
      }
    } catch (error) {
      setOpen(false);
      console.log(error);
      await setTimeout(async () => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something Went Wrong !! Please check your network ",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }, 100);
      await markColseModal();
    }
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    // footerGroups,
    rows,
    page,
    nextPage,
    canNextPage,
    previousPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    // state,
    setGlobalFilter,
    selectedFlatRows,
    setColumnOrder,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data,
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
  );

  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: {
            color: "red",
          },
        },
      },
    },
    palette: {
      primary: {
        main: "#FFA500", //this overide blue color
        // light: "#fff", //overides light blue
        // dark: "#fff", //overides dark blue color
      },
    },
  });

  const resetValues = useRef(null);
  const nextPageRef = useRef(null);

  const markclose = useRef(null);

  const markColseModal = async () => {
    await markclose.current.click();
  };
  const markAttendacne = async () => {
    try {
      setOpen(true);
      const res = await common_axios.post(`/attendance/viewAttendance`, {
        userId: localStorage.getItem("UserId"),
        year: datee.year,
        month: datee.month,
      });

      if (res.data.statusDescriptions.statusCode == 200) {
        setOpen(false);

        setData(res.data.attendanceEntity);

        res.data.attendanceEntity.map((e) => {
          setee1({
            ...e,
            dateform: moment(e.date).format("DD-MM-YYYY"),
          });
        });

        // x.toLocaleDateString()
      } else {
        setOpen(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescriptions.statusDescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      console.log(error);
      setOpen(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something Went Wrong !! Please check your network ",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  const buttonstatus = useSelector((state) => state.buttonSlice.button);

  useEffect(() => {
    markAttendacne();
  }, [buttonstatus]);

  const Viewattendanceofemp = async () => {
    try {
      setOpen(true);
      const res = await common_axios.post(`/attendance/viewAttendance`, {
        userId: employeesValue?.id,
        year: datee.year,
        month: datee.month,
      });

      if (res.data.statusDescriptions.statusCode == 200) {
        setOpen(false);
      } else {
        setOpen(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescriptions.statusDescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      console.log(error);
      setOpen(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something Went Wrong !! Please check your network ",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  useEffect(() => {
    let newform = moment(new Date()).format("DD-MM-YYYY");

    if (ee1.dateform == newform) {
      setshyamCode(ee1);
    }
  }, [ee1.dateform]);

  const getButtonAdd = useSelector(
    (datar) => datar?.EmployeeSlice?.employeebutton
  );

  const dispatch = useDispatch();

  return (
    <>
      {" "}
      <section class="form_card mt-4">
        <ToastContainer autoClose={5000} />

        <Backdrop
          sx={{
            transform: "translateZ(0)",
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
        >
          <Loader />
        </Backdrop>

        <>
          <button
            ref={mark}
            type="button"
            className="btn btn-primary d-none"
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop9"
          >
            Launch static backdrop modal
          </button>

          <div
            className="modal fade"
            id="staticBackdrop9"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabindex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="staticBackdropLabel">
                    Mark Attendance
                  </h5>
                  <button
                    ref={markclose}
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <ThemeProvider theme={theme}>
                  <div className="modal-body">
                    <div className="row">
                      {shyamCode?.status == 1 ? (
                        <div class="text-center">
                          <h6>Already Marked Present For Today</h6>
                        </div>
                      ) : shyamCode?.status == 2 ? (
                        <div class="text-center">
                          <h6>Already Marked Casual-Leave For Today</h6>
                        </div>
                      ) : shyamCode?.status == 0 ? (
                        <div class="text-center">
                          <h6>Already Marked Absent For Today</h6>
                        </div>
                      ) : shyamCode?.status == 3 ? (
                        <>
                          <div class="text-center">
                            <h6>Already Marked Optional-off For Today</h6>
                          </div>
                        </>
                      ) : (
                        <h6>{stat}</h6>
                      )}
                    </div>
                  </div>
                </ThemeProvider>
                <div className="modal-footer">
                  {shyamCode?.status == null || undefined ? (
                    <Button
                      type="button"
                      variant="contained"
                      sx={{ background: "#F96B02", color: "white" }}
                      endIcon={<StarsIcon />}
                      onClick={markAttendence}
                    >
                      Mark
                    </Button>
                  ) : null}

                  <Button
                    ref={markclose}
                    data-bs-dismiss="modal"
                    sx={{ marginLeft: "10px", background: "#4C4234" }}
                    variant="contained"
                    endIcon={<CancelIcon />}
                  >
                    Close
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </>

        {/* <Dialog
          open={open}
          TransitionComponent={Transition}
          keepMounted
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle>
            {"Would You Like to Mark Attendance for Today's Date"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText
              class="fw-bold"
              id="alert-dialog-slide-description"
              sx={{ fontWeight: "20px" }}
            >
            
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setOpen(false);
              }}
            >
              Yes Sure
            </Button>
            <Button
              onClick={() => {
                setOpen(false);
              }}
            >
              No Thanks
            </Button>
          </DialogActions>
        </Dialog> */}

        <div class="container-fluid" id="cont_fluid">
          <div class="card d-block" id="new_store_entry">
            <div class="card-header p-3 position-relative border-0 bg-white">
              <div class="ttl_bx position-absolute d-flex mt_n4">
                <i class="fas fa-user d-block m-auto"></i>
              </div>
              <div class="d-flex justify-content-between title_8 ms_5 px-2">
                <p>Mark Attendance </p>
              </div>
            </div>
            {/* <ul class="nav nav-tabs ms-4 mt-4" id="myTab" role="tablist">
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link active"
                  id="home-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#home"
                  type="button"
                  role="tab"
                  aria-controls="home"
                  aria-selected="true"
                >
                  Add Location
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button
                  disabled={getButtonAdd}
                  ref={nextPageRef}
                  // value={tabToggle}
                  class="nav-link"
                  id="profile-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#profile"
                  type="button"
                  role="tab"
                  aria-controls="profile"
                  aria-selected="false"
                >
                  Add Employee
                </button>
              </li>
            </ul> */}
            <div class="card-body p-4 mt-5 tab-content" id="myTabContent">
              <div
                class="tab-pane fade show active"
                id="home"
                role="tabpanel"
                aria-labelledby="home-tab"
              >
                <form class="m-0">
                  <div class="card card_8 d-block">
                    <div class="d-flex align-items-center w_30 mt_n3 ms-5 me-auto">
                      <i class="fas fa-envelope d-block" aria-hidden="true"></i>
                      <span class="d-block w-100 text-uppercase ms-2">
                        mark attendance
                      </span>
                    </div>

                    <div class="card-body">
                      <ThemeProvider theme={theme}>
                        <div className="formisform">
                          <>
                            <div className="row">
                              {/* <div className="col-md-3">
                                <Autocomplete
                                  fullWidth
                                  required
                                  size="small"
                                  disablePortal
                                  id="combo-box-demo"
                                  options={employees}
                                  getOptionLabel={(option) =>
                                    `${option.firstName}` +
                                    " " +
                                    `${option.lastName}`
                                  }
                                  value={employeesValue}
                                  onChange={(e, val) => {
                                    setEmployessValue(val);
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      required
                                      {...params}
                                      size="small"
                                      label="Employee Name"
                                    />
                                  )}
                                />
                              </div> */}

                              <div className="col-md-6 fw-bold">
                                <span>{stat}</span>
                              </div>
                            </div>
                          </>
                        </div>
                        {shyamCode?.status == 1 ? (
                          <div class="text-center mt-3 ">
                            <h4>Already Marked Present For Today</h4>
                          </div>
                        ) : shyamCode?.status == 2 ? (
                          <div class="text-center  mt-3">
                            <h4>Already Marked Casual-Leave For Today</h4>
                          </div>
                        ) : shyamCode?.status == 0 ? (
                          <div class="text-center mt-3 ">
                            <h4>Already Marked Absent For Today</h4>
                          </div>
                        ) : shyamCode?.status == 3 ? (
                          <>
                            <div class="text-center  mt-3">
                              <h4>Already Marked Optional-off For Today</h4>
                            </div>
                          </>
                        ) : null}
                      </ThemeProvider>
                      <div class="text-end my-4">
                        {shyamCode?.status == null || undefined ? (
                          <Button
                            type="button"
                            //   disabled={buttonDisable}
                            variant="contained"
                            sx={{ background: "#F67503" }}
                            endIcon={<SendIcon />}
                            onClick={() => {
                              markModal();
                            }}
                          >
                            Mark Attendance
                          </Button>
                        ) : null}
                      </div>
                      <div className="text-end">
                        <p> See Full Attendance</p>
                        <Link className="primary" to="/">
                          <p style={{ color: "#F47C03" }}>Click here !!</p>
                        </Link>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              {/* </div> */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
